import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Input from "../../../../../components/textbox/Input";
import Button from "../../../../../components/button/Button";
import Utils from "../../../../../utils/Utils";


class TableAllegatoTossinfezione extends Component {


    constructor(props) {
        super(props);
        this.handleChangesNote = this.handleChangesNote.bind(this);
        this.eliminaAllegato = this.eliminaAllegato.bind(this);
    }

    handleChangesNote(field, event) {
        let file = this.props.file;
        file.note = event.target.value;
        if (!file.isNewFile) {
            file.stato = "modifica";
            file.checked = true;
            this.props.setStatePadre({fileCaricato: file});
        } else this.props.setStatePadre({fileDaCaricare: file});
    }

    eliminaAllegato() {
        let file = Array.isArray(this.props.file) ? this.props.file[0] : this.props.file;
        if (file.isNewFile) {
            this.props.setStatePadre({fileDaCaricare: null})
        } else {
            file.stato = "eliminazione"
            file.checked = false
            this.props.setStatePadre({fileCaricato: null, fileDaCaricare: null, fileDaEliminare: file})
        }

    }

    render() {
        const {t} = this.props;

        let file = this.props.file

        const bodyFileCaricato = (
            <tr>
                <td>{file.name??file.nome}</td>
                <td>{file.data}</td>
                <td>
                    {<Input id={"noteFile"}
                            onChange={this.handleChangesNote}
                            value={file.note ? file.note : ""}
                            placeholder={"Note"}/>}
                </td>
                <td>
                    <Button text={t("SchedaFlussoSpeciale.Button.visualizza_pdf")}
                            className="btnBlu"
                            disabled={!this.props.isNewFile}
                            onClick={(e) => {
                                Utils.visualizzaPdf(e, null, this.props.segnalazioneCopia, this.props.showSpinner)
                            }}
                            style={{width: "150px", height: "40px"}}>
                    </Button>
                </td>
                <td>
                    <Button text={"Elimina allegato"}
                            className="btnBlu"
                            disabled={false}
                            onClick={this.eliminaAllegato}
                            style={{width: "150px", height: "40px"}}>
                    </Button>
                </td>
            </tr>
        )

        const tableAllegati = (
            <div className="d-flex justify-content-center">
                <table className="table table-bordered w-75" style={{marginTop: "2rem"}}>
                    <thead>
                    <tr className="table-info" style={{fontWeight: "bold"}}>
                        <td scope="col">{t("Tables.schedaSpecialeFile.nome")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.data")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.note")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.btnVisualizza")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.btnElimina")}</td>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.file ? bodyFileCaricato : null}
                    </tbody>
                </table>
            </div>

        );
        let emptyFile = {};

        return (
            <div>
                {this.props.file !== emptyFile ? tableAllegati : null}
            </div>);
    }


}


export default withTranslation('common')(TableAllegatoTossinfezione)
